import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { coefficientActions } from '../../../../actions/coefficientActions';
import CoefficientsForm from './CoefficientForm';

const CoefficientModal = props => {
  const { coefficients, handleSubmit, handleModalClose } = props;

  return (
    <Dialog
      open={coefficients.showFormModal}
      onClose={handleModalClose}
      aria-labelledby="form-dialog-title"
    >
      <Toolbar className="text-center">
        <Typography variant="title" color="inherit" className="flex">
          {coefficients.currentItem ? 'Редактирование коэффициента' : 'Создание коэффициента'}
        </Typography>
        <IconButton color="inherit" onClick={handleModalClose}>
          <CloseIcon className="blue" />
        </IconButton>
      </Toolbar>

      <DialogContent className="dialog text-center">
        <CoefficientsForm currentItem={coefficients.currentItem} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = state => {
  const { coefficients } = state;

  return {
    coefficients
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { coefficients } = stateProps;
  const { dispatch } = dispatchProps;

  const handleSubmit = (values, dispatch) => {
    if (coefficients.currentItem && coefficients.currentItem.id) {
      return dispatch(coefficientActions.update(values));
    }
    return dispatch(coefficientActions.create(values));
  };

  const handleModalClose = () => {
    dispatch(coefficientActions.closeFormModal());
  };

  return {
    ...ownProps,
    coefficients,
    handleSubmit,
    handleModalClose
  };
};

const connectedCoefficientModal = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CoefficientModal);

export { connectedCoefficientModal as CoefficientModal };
